<ng-container *ngIf="{ loading: loading$ | async, subtitle: subtitle$ | async } as obs">
  @if (obs.loading || obs.subtitle === null) {
    <span class="subtitle skeleton"></span>
  }

  @if (!obs.loading && obs.subtitle) {
    <span class="text-b4-m-300 text-md-b3-s-300 text-lg-b2-s-300 subtitle">{{ obs.subtitle }}</span>
  }
</ng-container>
